import * as React from 'react';

import { cn } from '@/slw/shared/lib/utils';
import { Textarea } from '@/slw/shared/ui/textarea';

type ChatInputProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  color?: 'default' | 'white' | 'main' | 'darkBlue' | 'darkGrey' | 'grey' | 'light';
};

const ChatInput = React.forwardRef<HTMLTextAreaElement, ChatInputProps>(({ className, ...props }, ref) => (
  <Textarea
    autoComplete='off'
    ref={ref}
    name='message'
    className={cn(
      `px-4 py-3 max-h-12 min-h-12 h-full bg-background text-sm placeholder:text-muted-foreground 
      focus-visible:outline-none focus-visible:ring-ring disabled:cursor-not-allowed 
      disabled:opacity-50 w-full rounded-md flex items-center resize-none',
      text-foreground`,
      className,
    )}
    {...props}
  />
));

ChatInput.displayName = 'ChatInput';

export { ChatInput };
